import { createAsyncThunk } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { getPrefix } from "features/Application/slices/models";
import { type CampaignSendOverview } from "../../types/state";
import { type CampaignSendsOverviewRequest } from "../../types/requests";
import { type FetchActionPayload } from "interfaces";
import DataService from "features/Application/services/dataServices/typedDataService";

export const fetchOverviewSends = createAsyncThunk<
  FetchActionPayload<CampaignSendOverview>,
  CampaignSendsOverviewRequest
>(
  getPrefix({
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.ThreatDefenceCampaigns,
    name: "sends",
  }),
  async (requestData: CampaignSendsOverviewRequest) => {
    const { campaignId, ...request } = requestData;

    const result = await DataService.threatDefence.campaigns.getCampaignSends(campaignId, request);

    return { items: result.items, totalCount: result.count };
  },
);

export const completeCampaignSend = (id: number) => async () => {
  await DataService.threatDefence.campaigns.completeCampaignRun(id);
};

export const cancelCampaignSend = (id: number) => async () => {
  await DataService.threatDefence.campaigns.cancelCampaignRun(id);
};
